import React from "react"
import AnchorButton from "@components/AnchorButton"
import Wrapper from "@components/Wrapper"
import styles from "./PricingSection.module.scss"
import { OutboundLink } from "@assertiv/assertiv-gatsby-plugin-google-gtag"


export default class PricingSection extends React.Component {

    render() {
        return (
            <section className="container-fluid bg-xl-light-gray">
                <div className="row ml-0 mr-0 mb-5">
                    <Wrapper className={"w-100 text-left"} gap="outer">
                        <div className="row bg-white justify-content-center p-10">
                            <div className={"col-sm-12 col-md 12 col-lg-6 col-xl-6"} >
                                <div className={styles.pricingPanel}>
                                    <div className={styles.pricesTop}>
                                        <div className={styles.priceHeaderSection}>
                                            <span className={styles.panelHeadingText}>SMALL / MEDIUM TEAMS</span><br />
                                            <span className={styles.priceText}>FREE</span>
                                            <span className={styles.priceCurrencyText}></span>
                                        </div>
                                        <hr className={styles.hrTeal} />
                                        <span className={styles.featureHeadingText}>5</span><br />
                                        Users
                                        <hr className={styles.hrGrey}  />
                                        <span className={styles.featureHeadingText}>Unlimited</span><br />
                                        Applications
                                        <hr className={styles.hrGrey}  />
                                        <span className={styles.featureHeadingText}>Unlimited</span><br />
                                        Roles
                                        <hr className={styles.hrGrey}  />
                                        <span className={styles.featureHeadingText}>Additional:</span><br />
                                        <OutboundLink href={"/features"}>View Included Features</OutboundLink>
                                    </div>
                                    <div className={styles.pricesMiddle}>
                                    <span className={styles.featureHeadingText}>Support:</span><br />
                                        Knowledgebase,<br />
                                        Support Articles<br /><br />
                                    </div>
                                    <div className={styles.pricesBottom}>
                                        <span className={styles.featureHeadingText}>Cost:</span><br />
                                        Free<br />
                                        <AnchorButton
                                            href="https://app.engineid.com/register"
                                            content="GET STARTED"
                                            className={styles.button}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className={"col-sm-12 col-md 12 col-lg-6 col-xl-6"} >
                                <div className={styles.pricingPanel}>
                                    <div className={styles.pricesTop}>
                                        <div className={styles.priceHeaderSection}>
                                            <span className={styles.panelHeadingText}>BUSINESS</span><br />
                                            <span className={styles.priceText}>$2 / User</span>
                                        </div>
                                        <hr className={styles.hrTeal} />
                                        <span className={styles.featureHeadingText}>Unlimited</span><br />
                                        Users
                                        <hr className={styles.hrGrey}  />
                                        <span className={styles.featureHeadingText}>Unlimited</span><br />
                                        Applications
                                        <hr className={styles.hrGrey}  />
                                        <span className={styles.featureHeadingText}>Unlimited</span><br />
                                        Roles
                                        <hr className={styles.hrGrey}  />
                                        <span className={styles.featureHeadingText}>Additional:</span><br />
                                        <OutboundLink href={"/features"}>View Included Features</OutboundLink>
                                    </div>
                                    <div className={styles.pricesMiddle}>
                                    <span className={styles.featureHeadingText}>Support:</span><br />
                                        Knowledgebase,<br />
                                        Support Articles,<br />
                                        Email and Helpdesk
                                    </div>
                                    <div className={styles.pricesBottom}>
                                        <span className={styles.featureHeadingText}>Cost:</span><br />
                                        $2 USD / User / Month<br />
                                        <AnchorButton
                                            href="https://app.engineid.com/register"
                                            content="GET STARTED"
                                            className={styles.button}
                                        />
                                    </div>
                                </div>
                            </div>
                            {/* <div className={"col-sm-12 col-md 12 col-lg-3 col-xl-3"} >
                                <div className={styles.pricingPanel}>
                                    <div className={styles.pricesTop}>
                                        <div className={styles.priceHeaderSection}>
                                            <span className={styles.panelHeadingText}>ENTERPRISE</span><br />
                                            <span className={styles.priceEnterpriseText}>CONTACT US</span>
                                        </div>
                                        <hr className={styles.hrTeal} />
                                        <span className={styles.featureHeadingText}>Unlimited</span><br />
                                        (min. 5000 active users)
                                        <hr className={styles.hrGrey}  />
                                        <span className={styles.featureHeadingText}>Unlimited</span><br />
                                        Applications
                                        <hr className={styles.hrGrey}  />
                                        <span className={styles.featureHeadingText}>Unlimited</span><br />
                                        Roles
                                        <hr className={styles.hrGrey}  />
                                        Single Sign-On<br />
                                        (SAML + OpenID Connect)
                                        <hr className={styles.hrGrey}  />
                                        Roles Based Access<br />
                                        <hr className={styles.hrGrey}  />
                                        Multi-Factor Auth<br />
                                        <hr className={styles.hrGrey}  />
                                        Passwordless<br />
                                        <hr className={styles.hrGrey}  />
                                        Access Request Workflow<br />
                                        <hr className={styles.hrGrey}  />
                                        Inbound SAML<br />
                                        <hr className={styles.hrGrey}  />
                                        Developer API<br />
                                        <hr className={styles.hrGrey}  />
                                        Identity Synchronization<br />
                                        <hr className={styles.hrGrey}  />
                                        Self Service Password Reset<br />
                                        <hr className={styles.hrGrey}  />
                                        Certificate Management<br />
                                    </div>
                                    <div className={styles.pricesMiddle}>
                                        <span className={styles.featureHeadingText}>Support:</span><br />
                                        24 x 7 Phone,<br />
                                        Knowledgebase, Support Articles,<br />
                                        Email and Helpdesk
                                    </div>
                                    <div className={styles.pricesBottom}>
                                        <span className={styles.featureHeadingText}>Cost:</span><br />
                                        Contact Us<br />
                                        <AnchorButton
                                            href="https://app.engineid.com/register"
                                            content="GET STARTED"
                                            className={styles.button}
                                        />
                                    </div>
                                </div>
                            </div> */}
                        </div>
                    </Wrapper>
                </div>
            </section>
        );
    }
}